<stream-player-info-component *ngFor="let player of (playersStream | async)" [playerModel]="player" [class.has-game-audio]="player.hasGameAudio">
</stream-player-info-component>
